import React from 'react'
import './fileDirectory.css'
import FileDirItem from './fileDirItem'

class FileDirectory extends React.Component {
    constructor(props) {
        super(props);
    }

    handleClickDir = (index) => {
        this.props.handleClickDir(index);
    }

    render() {
        let directory = this.props.directory;
        return(
            <div className='div_directory'>{
                directory.map((item, index) => {
                        if (index == directory.length - 1) {
                            return <FileDirItem key={index}
                                                className='h6_nochangeline'
                                                item={item}
                                                isLast={true}
                                                handleClickDir={this.handleClickDir}
                                                depth={index}/>
                        } else {
                            return <FileDirItem key={index}
                                                className='h6_nochangeline'
                                                item={item + '>'}
                                                isLast={false}
                                                handleClickDir={this.handleClickDir}
                                                depth={index}/>
                        }
                    }
                )
            }
            </div>
        );
    }
}

export default FileDirectory